import { IGroup } from '../types/types';
import { graphQLPost } from '../utilities';

export interface School {
    Id: number,
    Name: string
}

export interface SchoolClass {
    Id: number,
    Name: string,
    SchoolId: number,
    SchoolName: string
}

export default class General {

    static async getStudents(): Promise<{ id:number, firstName:string, lastName: string, socialSecurityNumber: string }[]> {
        try {
            const response
                = await graphQLPost(
                    `{ students { id firstName lastName, socialSecurityNumber, programName, className, schoolUnitCode} }`, {}
                );

            return response.students as { id: number, firstName: string, lastName: string, socialSecurityNumber: string }[];
        } catch (error) {
            console.error(error);
            throw("Fel vid hämtning av studenter...");
        }
    }

    static async getCourses(): Promise<{ id:number, name:string, displayName:string }[]> {
        try {
            const response
                = await graphQLPost(
                    `{ courses { id name displayName } }`, {}
                );

            return response.courses as { id: number, name: string, displayName: string }[];
        } catch (error) {
            console.error(error);
            throw("Fel vid hämtning av kurser/ämnen...");
        }
    }

    static async getAllCourses(): Promise<{ id:number, name:string, displayName:string }[]> {
        try {
            const response
                = await graphQLPost(
                    `{ coursesAll { id name displayName } }`, {}
                );

            return response.coursesAll as { id: number, name: string, displayName: string }[];
        } catch (error) {
            console.error(error);
            throw("Fel vid hämtning av kurser/ämnen...");
        }
    }

    static async getClasses(): Promise<{ id:number, name:string, school: { id:number, name:string } | null }[]> {
        try {
            const response
                = await graphQLPost(
                    `{ classes { id name school { id name } } }`, {}
                );

            return response.classes as { id:number, name:string, school: { id:number, name:string } | null }[];
        } catch (error) {
            console.error(error);
            throw("Fel vid hämtning av klasser...");
        }
    }

    static async getAllClasses(): Promise<{ id:number, name:string, school: { id:number, name:string } | null }[]> {
        try {
            const response
                = await graphQLPost(
                    `{ classesAll { id name school { id name } } }`, {}
                );

            return response.classesAll as { id:number, name:string, school: { id:number, name:string } | null }[];
        } catch (error) {
            console.error(error);
            throw("Fel vid hämtning av klasser...");
        }
    }

    static async getTeachers(): Promise<{ id:number, fullname: string, externalId: string }[]> {
        try {
            const response
                = await graphQLPost(
                    `{ teachers { id fullname externalId } }`, {}
                );

            return response.teachers as { id:number, fullname: string, externalId: string }[];
        } catch (error) {
            console.error(error);
            throw("Fel vid hämtning av lärare...");
        }
    }

    static async getAllPrograms(): Promise<{ id:number, code: string, name: string, schoolUnitId: number }[]> {
        try {
            const response
                = await graphQLPost(
                    `{ programs { id code name schoolUnitId } }`, {}
                );

            return response.programs as { id:number, code: string, name: string, schoolUnitId: number }[];
        } catch (error) {
            console.error(error);
            throw("Fel vid hämtning av program...");
        }
    }
    
    static async getUnits(): Promise<{ id:number, name:string }[]> {
        try {
            const response
                = await graphQLPost(
                    `{ units { id name } }`, {}
                );

            return response.units as { id: number, name: string }[];
        } catch (error) {
            console.error(error);
            throw("Fel vid hämtning av enheter...");
        }
    }

    static async getSchools(): Promise<{ id:number, name:string }[]> {
        try {
            const response
                = await graphQLPost(
                    `{ schools { id name } }`, {}
                );

            return response.schools as { id: number, name: string }[];
        } catch (error) {
            console.error(error);
            throw("Fel vid hämtning av skolor...");
        }
    }

    static async getAllSchools(): Promise<{ id:number, name:string }[]> {
        try {
            const response
                = await graphQLPost(
                    `{ schoolsAll { id name } }`, {}
                );

            return response.schoolsAll as { id: number, name: string }[];
        } catch (error) {
            console.error(error);
            throw("Fel vid hämtning av skolor...");
        }
    }

    static async getGroups(): Promise<IGroup[]> {
        try {
            const response
                = await graphQLPost(
                    `{ groups { id name } }`, {}
                );

            return response.groups as IGroup[];
        } catch (error) {
            console.error(error);
            throw("Fel vid hämtning av grupper...");
        }
    }
}